import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  padding: 0px 20px 50px 20px;
  margin-top: 100px;

  @media (max-width: 867px) {
    margin-top: 200px;
  }
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: end;
  flex-direction: column;
  gap: 60px;

  h1 {
    color: #139ed5;
    font-size: 40px;
    font-family: "Noto Serif";
    text-align: center;
  }
`;

export const Cards = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 867px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Card = styled.div`
  max-width: 620px;
  width: 100%;
  height: 250px;
  border-bottom: 3px solid #139ed5;
  border-radius: 10px;
  display: flex;
  gap: 20px;
  align-items: center;
  font-family: "Noto Serif";
  background-color: white;

  img {
    border-radius: 10px 0 0 0px;
    padding-bottom: 3px;
  }

  h3 {
    color: #139ed5;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
  }

  ul {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    font-family: "Montserrat";
    padding-left: 20px;
  }

  @media (max-width: 495px) {
    flex-direction: column;
    height: 100%;
    padding: 20px;

    img {
      border-radius: 10px;
    }
  }
`;
